export default __webpack_public_path__ + "static/banner-christmas-new-york-4f1a9322c5d9b4c42d7b832861d56561.jpg";